import { useQuery } from 'react-query'
import {
  getNordicLookupWindows,
  NordicLookupWindowsParams,
} from 'services/cm-api/get-nordic-lookup-windows'

// Loaded lazily: the page enables it only when a customer row is expanded.
export function useNordicLookupWindows(
  customerId: number,
  params: NordicLookupWindowsParams = {},
  { enabled }: { enabled: boolean } = { enabled: true },
) {
  return useQuery(
    ['getNordicLookupWindows', customerId, params],
    () => getNordicLookupWindows(customerId, params),
    {
      enabled: enabled && Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
      keepPreviousData: true,
      staleTime: 60_000,
    },
  )
}
